import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericHttp } from './generic-http.service';
import { Config } from '@config/config.service';

@Injectable()
export class UserApiService {
  private companyProfilesUrl: string;
  private usersDataUrl: string;
  private agentCompaniesUrl: string;
  private companyProfilesOfferUrl: string;

  constructor(
    private trbhttp: GenericHttp,
    private config: Config,
  ) {
    this.companyProfilesUrl = config.companyProfilesUrl;
    this.usersDataUrl = config.usersDataUrl;
    this.agentCompaniesUrl = config.agentCompaniesUrl;
    this.companyProfilesOfferUrl = config.companyProfilesOfferUrl;
  }

  createUser(data): Observable<any> {
    return this.trbhttp.post(this.usersDataUrl, data);
  }

  getCompanyProfiles(): Observable<any> {
    return this.trbhttp.get(this.companyProfilesUrl);
  }

  getCompanyOfferProfiles(offerId: string): Observable<any> {
    const url = this.companyProfilesOfferUrl.replace('{offerId}', offerId);

    return this.trbhttp.get(url);
  }

  getAgentCompanies(): Observable<any> {
    return this.trbhttp.get(this.agentCompaniesUrl);
  }

  getUsersData(filterData): Observable<any> {
    return this.trbhttp.get(
      this.usersDataUrl,
      filterData
    );
  }
}
